<template>
  <div :id="id" class="row align-items-center">
    <LmTextInput
      ref="inputFocus"
      :id="`label-${id}`"
      class="col-12 col-md-4"
      v-model="component.componentProps.label"
      @input="onLabelChange($event)"
      :label="$t('title')"
      :placeholder="$t('title')"
      :help="$t('comp_title_help')"
    />
    <LmTextInput
      v-if="validateSuperUser"
      :id="`nombre-${id}`"
      class="col-12 col-md-4"
      v-model="component.formObjectToSendToServerProperty"
      @input="$emit('input', component); $emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
      :label="$t('name')"
      :placeholder="$t('name')"
      :help="$t('comp_name_help')"
    />
    <LmSelect
      :id="`default-option-${id}`"
      class="col-12 col-md-4"
      v-model="component.componentProps.defaultValue"
      @input="$emit('input', component)"
      :label="$t('default_option')"
      :placeholder="$t('select_an_option')"
      :options="defaultOptionOptions"
    />
    <LmSelect
      :id="id + 'css'"
      class="col-12 col-md-4"
      v-model="component.class"
      :options="{
        content: [
          {value: 'col-12 col-md-3',text: '25%'},
          {value: 'col-12 col-md-6', text: '50%'},
          {value: 'col-12 col-md-9', text: '75%'},
          {value: 'col-12 col-md-12', text: '100%'}
        ]
      }"
      :label="$t('desktop_view_width')"
      :help="$t('help_width_form_element')"
      @input="$emit('input', component)"
    />
    <LmSelect
      :id="id + 'size'"
      class="col-12 col-md-4"
      v-model="component.componentProps.size"
      :options="{
        content: [
          {value: 'sm',text: $t('small')},
          {value: 'md', text: $t('medium')},
          {value: 'lg', text: $t('large')}
        ]
      }"
      :label="$t('size')"
      @input="$emit('input', component)"
    />
    <LmCheckbox
      class="col-12 col-md-4"
      :labelSingle="$t('comp_is_vertical')"
      v-model="component.componentProps.isVertical"
      @input="$emit('input', component)"
    />
    <LmSelect
      :id="id + 'variant'"
      class="col-12 col-md-4"
      v-model="component.componentProps.variant"
      :options="{
        content: [
          {value: 'radio',text: $t('comp_radios')},
          {value: 'button', text: $t('comp_buttons')}
        ]
      }"
      :label="$t('variant')"
      @input="$emit('input', component)"
    />
    <LmTextInput
      v-if="component.componentProps.variant === 'button'"
      :id="`button-variant-class-${id}`"
      class="col-12 col-md-4"
      v-model="component.componentProps.buttonsClass"
      @input="$emit('input', component)"
      :label="$t('comp_styles')"
      :placeholder="$t('comp_styles')"
    />
    <div class="col-12">
      <h5>{{ $t('options') }}</h5>
      <div
        v-for="(option, index) in component.componentProps.options"
        :key="index"
        class="row align-items-center"
      >
        <LmTextInput
          :id="`text-${id}-${index}`"
          class="col-md-5"
          v-model="component.componentProps.options[index].text"
          @input="onOptionTextChange($event, index)"
          :label="$t('text')"
          :placeholder="$t('text')"
        />
        <LmTextInput
          v-if="$store.getters['session/userRole'] === 'Superusuario'"
          :id="`value-${id}-${index}`"
          class="col-md-5"
          v-model="component.componentProps.options[index].value"
          @input="$emit('input', component)"
          :label="$t('value')"
          :placeholder="$t('value')"
        />
        <font-awesome-icon
          :id="`trash-icon-${index}`"
          v-if="isAtLeastOneOption"
          class="clickable mt-3 col-2"
          icon="trash"
          @click="removeOption(index)"
        />
      </div>
      <LmButton
        :id="`lm-button-${id}`"
        type="button"
        :value="$t('add_option')"
        @click="addOption"
      />
    </div>
    <hr class="w-100 mx-2">
    <div class="col-12">
      <h5>{{ $t('validations') }}</h5>
      <div class="row align-items-center">
        <LmCheckbox
          class="col-12 col-md-4"
          :labelSingle="$t('required')"
          v-model="validations.required"
          @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
        />
      </div>
    </div>
    <hr class="w-100 mx-2">
    <LmConditionalBuilderUi
      v-if="isVisibleCondition"
      class="col-12"
      :visibilityDependOnConditions="visibilityDependOnConditions"
      :self="component.formObjectToSendToServerProperty"
    />
    <LmConditionalByEditModeBuilderUi
      :component="component"
      @input="$emit('input', component)"
      />
  </div>
</template>

<script>
import LmButton from '@/components/form/elements/LmButton'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmSelect from '@/components/form/elements/LmSelect'
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'
export default {
  mixins: [lmFormElementsBuilderUiMixin],
  data () {
    return {
      validations: {
        required: false
      }
    }
  },
  components: {
    LmButton,
    LmCheckbox,
    LmSelect
  },
  computed: {
    isAtLeastOneOption () {
      return this.component.componentProps.options.length > 1
    },
    defaultOptionOptions () {
      const options = {
        content: [
          { value: '', text: this.$t('none'), disabled: true }
        ]
      }
      if (this.component.componentProps.options.length) {
        options.content = options.content.concat(this.component.componentProps.options)
      }
      return options
    }
  },
  methods: {
    addOption () {
      const count = this.component.componentProps.options.length + 1
      this.component.componentProps.options.push({ text: `Opción ${count}`, value: `Opción ${count}` })
    },
    removeOption (optionIndex) {
      this.component.componentProps.options.splice(optionIndex, 1)
    },
    onOptionTextChange (event, index) {
      this.component.componentProps.options[index].value = event
      this.$emit('input', this.component)
    }
  },
  watch: {
    componentData () {
      this.component = this.componentData
    }
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    }
  }
}
</script>
